import React from 'react';

interface AlertBoxProps {
    alert: string;
    typeOfAlert: string;
}

const AlertBox = ({ alert, typeOfAlert }: AlertBoxProps) => {
    let inputClass = 'col-sm-8 col-md-6';
    if (typeOfAlert === 'error') {
        inputClass += ' text-danger';
    }
    if (typeOfAlert === 'warning') {
        inputClass += ' text-warning';
    }

    return (
        <>
            <div className="form-group">
                <div className="control-label col-sm-4 col-md-3"></div>
                <div className={inputClass} style={{ marginTop: '-10px' }}>
                    {alert}
                </div>
            </div>
        </>
    );
};

export default AlertBox;
